/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { withStyles } from "@mui/styles";
import { Button, Dialog, IconButton } from "@mui/material";

import MuiDialogActions from "@mui/material/DialogActions";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";

import CloseIcon from "@mui/icons-material/Close";
import { red } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const theme = createTheme({});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 2,
  },
  closeButton: {
    position: "absolute",
    right: 2,
    top: 2,
    padding: 2,
    color: "#ffffff",
  },
});

const ColorButton = styled(Button)({
  color: theme.palette.getContrastText(red[500]),
  backgroundColor: red[500],
  "&:hover": {
    backgroundColor: red[700],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={classes.root}
      {...other}
      style={{
        paddingTop: 5,
        paddingLeft: 10,
        paddingBottom: 2,
        background: "#3282b8",
        color: "#eeeeee",
      }}
    >
      <Typography variant="button" display="block">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon
            style={{
              background: "#db0202",
            }}
          />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: 8,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: 4,
  },
}))(MuiDialogActions);

export default function PConfirm(props) {
  const { t } = useTranslation();
  const translate = t;
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    props.onButtonClicked(props.context, "cancel");
  };

  useEffect(() => {
    setOpen(true);
    console.log(props);
  }, []);

  function onNo() {
    setOpen(false);
    props.onButtonClicked(
      props.context,
      "no",
      props.context.confirmContextType
    );
  }
  function onYes() {
    setOpen(false);
    props.onButtonClicked(
      props.context,
      "yes",
      props.context.confirmContextType
    );
  }

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={props.maxWidth}
        fullWidth={props.fullWidth}
        disableBackdropClick={true}
        disableEscapeKeyDown={false}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {props.context.title}
        </DialogTitle>
        <DialogContent dividers>{props.context.message}</DialogContent>

        <DialogActions>
          {props.context.no && !props.touchFriendly && (
            <Button onClick={onNo} variant="contained" color="primary">
              {props.context.noLabel ? props.context.noLabel : translate("No")}
            </Button>
          )}
          {props.context.yes && !props.touchFriendly && (
            <Button onClick={onYes} variant="contained" color="primary">
              {props.context.yesLabel
                ? props.context.yesLabel
                : translate("Yes")}
            </Button>
          )}

          {/* button for touch screen */}

          <div>
            {props.context.no && props.touchFriendly && (
              <Button
                onClick={onNo}
                variant="contained"
                color="error"
                size="large"
                sx={{ mb: "5px", mt: "5px" }}
              >
                {props.context.noLabel
                  ? props.context.noLabel
                  : translate("No")}
              </Button>
            )}
            {props.context.yes && props.touchFriendly && (
              <Button
                onClick={onYes}
                variant="contained"
                color="success"
                size="large"
                sx={{ ml: "18px", mr: "10px", mb: "5px", mt: "5px" }}
              >
                {props.context.yesLabel
                  ? props.context.yesLabel
                  : translate("Yes")}
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
